import { type CollectUsageDataResponse, UsageCollectorApi } from './UsageCollectorApi';
import type { Api } from '@automapa/svelte-automapa-template';

export class UsageCollectorApp {
    private usageData: CollectUsageDataResponse[] = [];
    private readonly api: Api;
    private customer_id: number | null = null;
    private _isLoading: boolean = true;
    private _error: string | null = null;

    constructor(api: Api) {
        this.api = api;
    }

    public async load(): Promise<void> {
        this.usageData = await UsageCollectorApi.collectUsageData(this.api, this.customer_id).catch(
            error => {
                this._error = error.message || 'Failed to load usage data';
                console.error('Error loading usage data:', this._error);
                return [];
            }
        );
        this._isLoading = false;
    }

    public getUsageData(): CollectUsageDataResponse[] {
        return this.usageData;
    }

    public getUniqueMonths(): string[] {
        const months = this.usageData.map(data => data.month);
        return Array.from(new Set(months)).sort(
            (a, b) => new Date(b).getTime() - new Date(a).getTime()
        );
    }

    public setCustomerId(customer_id: number | null): void {
        this.customer_id = customer_id;
    }

    public isLoading(): boolean {
        return this._isLoading;
    }

    public getError(): string | null {
        return this._error;
    }

    public hasError(): boolean {
        return this._error !== null;
    }
}
